export const initialState = {
	brand: [],
	brandCategoy:[],
	categoryLoading: false,
	categoryError: '',
	loading: false,
	error: '',
};